import {
  Component,
  OnInit,
  ViewChild,
  HostBinding,
  ComponentRef,
  ElementRef,
  HostListener,
  ViewRef,
  Input
} from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { LayoutHostDirective } from '../layout-host.directive';
import { AbstractControlContainerComponent } from '../../controls/abstract-control-container/abstract-control-container.component';

import { ToolAdapterService } from '../../tools/tool-adapter.service';
import { DesignerConfigurationService } from '../../services/designer-configuration.service';
import { DragService } from '../../services/drag.service';

import {
  ContainerViewModel,
  AbstractControl,
  ControlLayoutModel,
  DesignHostContainer,
  DynamicControlContainer,
  ControlViewModel
} from '../../types/control.types';
import { ControlDataModel } from '../../types/control.types';
import { ControlTranslate } from '../../utils';

@Component({
  // tslint:disable-next-line: component-selector
  selector: '[dy-design-host]',
  templateUrl: './design-host.component.html',
  styleUrls: ['./design-host.component.scss']
})
export class DesignHostComponent extends AbstractControlContainerComponent<ContainerViewModel>
  implements DesignHostContainer, OnInit {
  get disableOperateControl(): boolean {
    return this.controlTranslate.disableOperateControl;
  }
  get selected(): boolean {
    return this._selected;
  }
  set selected(value: boolean) {
    this._selected = value;
  }
  controlTranslate: ControlTranslate;

  type: string = 'DesignHost';
  isDesign: boolean = true;
  isContainer: boolean = true;
  model: ContainerViewModel;
  control: AbstractControl<any> | any;

  @HostBinding()
  get class(): string {
    let c = 'design-host ' + (this.selected ? 'selected ' : '');
    if (this.isContainer) {
      c = c + (this.control ? this.control.designHostClass : '');
    }
    return c;
  }

  @ViewChild(LayoutHostDirective) layoutHost: LayoutHostDirective;
  parentHost: DynamicControlContainer;
  componentRef: ComponentRef<any>;

  private _selected: boolean;

  constructor(
    private configuration: DesignerConfigurationService,
    protected element: ElementRef,
    private toolAdapter: ToolAdapterService,
    private dragService: DragService
  ) {
    super();
  }

  ngOnInit() {}

  getViewIndex(): number {
    return this.parentHost.layoutHost.viewContainerRef.indexOf(this.componentRef.hostView);
  }

  getDataModel(): ControlDataModel {
    return this.control.getDataModel();
  }

  addControls(controls: Array<ControlLayoutModel>): Observable<AbstractControl<ControlViewModel>[]> {
    this.controlTranslate.sendLoadComponentModel({
      layoutModel: controls,
      dynamicControlContainer: this,
      isDesign: undefined
    });
    return null;
  }
  addControl(control: ControlLayoutModel): Observable<AbstractControl<ControlViewModel>> {
    const sub = new Subject<AbstractControl<ControlViewModel>>();
    this.controlTranslate.sendLoadComponentModel({
      layoutModel: control,
      dynamicControlContainer: this,
      isDesign: undefined,
      result: (c) => {
        const s = c as AbstractControl<ControlViewModel>;
        this.control = s;
        this.control.isDesign = true;
      }
    });
    return sub;
  }

  moveUpView(hostView: ViewRef): void {
    throw new Error('Method not implemented.');
  }
  moveDownView(hostView: ViewRef): void {
    throw new Error('Method not implemented.');
  }

  select() {
    const specification = this.configuration.findControlSpecification(this.control.type);
    this.toolAdapter.do(this, {
      control: this.control,
      specification: specification
    });
  }

  cut() {
    this.toolAdapter.startCut(this);
  }

  copy() {
    this.toolAdapter.startCopy(this);
  }

  remove() {
    const index = this.getViewIndex();
    this.parentHost.removeControl(index);
  }

  moveUp() {
    this.toolAdapter.moveUp(this);
  }

  moveDown() {
    this.toolAdapter.moveDown(this);
  }

  /**
   * @description çå¬é¼ æ å¨è¿ä¸ªæ§ä»¶ä¸éæ¾
   *
   * @param event
   * @memberof DesignHostComponent
   */
  @HostListener('mouseup', ['$event']) onMouseup(event: any) {
    this.dragService.sendDragEndAtControl(this);
  }
}
